// extracted by mini-css-extract-plugin
module.exports = {"root":"cjNU_","iconArea":"xflLS"};